document.addEventListener('DOMContentLoaded', () => {
    //skip script on admin panel
    if (window.Shopify && Shopify.designMode) {
        return;
    }

    //file: nav-item.liquid
    function addDropdownButtonToToggle() {
        document.querySelectorAll('.ally-dropdown-toggle').forEach(button => {
            const link = button.previousElementSibling;
            const dropdown = button.nextElementSibling;
            dropdown.tabIndex = '-1';

            button.addEventListener('click', () => {
                const activeState = button.getAttribute('aria-expanded') === 'true';
                if(activeState) {
                    closeDropdown(dropdown);
                } else {

                // simulate hover
                emitHoverState(link);
                }

                button.setAttribute('aria-expanded', !activeState);
                
            })

            button.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    button.click();
                    return;
                }

                if(e.key === 'Escape') {
                    e.preventDefault();
                    closeDropdown(dropdown);
                }
            });


        });

        function closeDropdown(dropdown) {
            dropdown.focus();
            const escapeEvent = new KeyboardEvent('keyup', {
                key: 'Escape',
                code: 'Escape',
                keyCode: 27,
                which: 27,
                bubbles: true
            });
            dropdown.dispatchEvent(escapeEvent);
        }

        function emitHoverState(targetElement) {
            const mouseEnterEvent = new MouseEvent('mouseenter', {
            bubbles: true,
            cancelable: true,
            view: window
            });
            targetElement.dispatchEvent(mouseEnterEvent);

            const mouseOverEvent = new MouseEvent('mouseover', {
            bubbles: true,
            cancelable: true,
            view: window
            });
            targetElement.dispatchEvent(mouseOverEvent);
        }
    }

    addDropdownButtonToToggle();



    function fixReviews() {
        if (!window.location.pathname.includes('/products')) return;
        const container = document.querySelector('.jdgm-rev-widg');

        if (!container) return;

        const updateReviewList = () => {
            const reviewsSection = container.querySelector('.jdgm-rev-widg__reviews');
            reviewsSection.querySelectorAll('.jdgm-rev').forEach(review => {
                fixReviewItem(review);
            });
        };

        const bodyreviews = document.querySelector('.jdgm-rev-widg__body');
        if(bodyreviews) {
            new MutationObserver(() => {
                updateReviewList();
            }).observe(bodyreviews, {
                childList: true,
                subtree: true
            });
        }

        fixBadges(container);
        fixRatingSection(container);
        fixAverage(container);
        updateReviewList();
        fixCountdown(container);
        fixEmailValidationMessage(container);
        fixNotificationAlert(container);
        focusFirstErrorOnSubmit(container);
        fixAskQuestionForm(container);
        tabListToReviewsQuestions(container);
        paginationSemantics(container);
        fixQuestionsSection(container);
        focusStarFirst(container);
        setAnnouncementToSuccessSubmissionMessage(container);
        fixRatingError(container);

        function fixRatingError(container) {
            const errorObserver = new MutationObserver(() => {
                const scoreError = container.querySelector('#score-error');
                
                if (scoreError) {
                    const fieldset = scoreError.closest('.jdgm-form__rating-fieldset');
                    if (fieldset && !fieldset.hasAttribute('aria-applied')) {
                        fieldset.setAttribute('aria-applied', 'true');
                        fieldset.querySelectorAll('.jdgm-star').forEach(star => {
                            star.setAttribute('aria-describedby', scoreError.id);
                        });
                    }
                    // No need to keep observing once found and fixed
                    errorObserver.disconnect();
                }
            });

            errorObserver.observe(container, {
                childList: true,
                subtree: true
            });
        }

        function setAnnouncementToSuccessSubmissionMessage(container) {
            const observer = new MutationObserver(() => {
                const message = document.querySelector('.jdgm-notification');
                if(message) {
                    message.setAttribute('role', 'alert');
                    observer.disconnect();
                }
            });

            observer.observe(container, {
                childList: true,
                subtree: true
            })
        }

        function focusStarFirst(container) {
            const observerReviewBtn = new MutationObserver(() => {
                const reviewBtn = container.querySelector('.jdgm-write-rev-link');
                if(reviewBtn) {
                    reviewBtn.addEventListener('click', () => {
                        if(reviewBtn.getAttribute('aria-expanded') === 'false') {

                            //related to fixCountdown()
                            const select = container.querySelector('.jdgm-form__reviewer-name-format-dropdown');
                            if (select) {
                                select.removeAttribute('data-focus-set');
                            }
                        }


                        setTimeout(() => {
                            const stars = container.querySelectorAll('.jdgm-form__fieldset a.jdgm-star');
                            if(stars.length > 0) {
                                stars[0].focus()
                            }
                        }, 200);
                    });

                    reviewBtn.addEventListener('click', (e) => {
                        if(e.key === 'Enter') {
                            e.preventDefault();
                            reviewBtn.click();
                        }
                    })

                observerReviewBtn.disconnect();
                }
            });

            observerReviewBtn.observe(container, {
                subtree: true,
                childList: true
            })
        }

        function paginationSemantics(container) {
            const observe = (paginationObserver) => {
                paginationObserver.observe(container, {
                    subtree: true,
                    childList: true
                });
            };
            
            const paginationObserver = new MutationObserver(() => {
                const pagination = container.querySelector('.jdgm-paginate');
                if(!pagination) return;

                const lastPage = pagination.querySelector('.jdgm-paginate__last-page')
                paginationObserver.disconnect();
                pagination.setAttribute('role', 'navigation');
                pagination.setAttribute('aria-label', 'Pagination');
                const pages = pagination.querySelectorAll(
                '.jdgm-paginate__page:not(.jdgm-paginate__next-page):not(.jdgm-paginate__last-page)'
                );

                let linkLabel = lastPage ? `of ${lastPage.getAttribute('data-page')}` : '';
                pages.forEach(page => {
                    page.setAttribute('aria-current', page.classList.contains('jdgm-curt'));
                    page.setAttribute('aria-label', `Page ${page.getAttribute('data-page')} ${linkLabel}`);
                    page.addEventListener('click', () => observe(paginationObserver));
                    page.addEventListener('keydown', (e) => {
                        if(e.key === 'Enter') observe(paginationObserver);
                    });
                });

                pagination.querySelectorAll('.jdgm-paginate__next-page, .jdgm-paginate__prev-page').forEach(page => {
                    page.setAttribute('tabindex', '-1');
                    page.setAttribute('aria-hidden', 'true');
                });
            })

            observe(paginationObserver);
        }

        function tabListToReviewsQuestions(container) {
            const tabsObserver = new MutationObserver(() => {
                const tabsContainer = container.querySelector('.jdgm-subtab');
                if(!tabsContainer) return;
                const tabs = Array.from(tabsContainer.querySelectorAll('.jdgm-subtab__name'));

                // Add tablist role
                tabsContainer.setAttribute('role', 'tablist');

                tabs.forEach((tab, index) => {
                    tab.setAttribute('role', 'tab');

                    const isActive = tab.classList.contains('jdgm--active');

                    tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                    tab.tabIndex = isActive ? 0 : -1;

                    // Assign an ID if none exists (required for tabpanel linking)
                    if (!tab.id) tab.id = `jdgm-tab-${index}`;

                    // Create aria-controls if missing (safe fallback)
                    if (!tab.hasAttribute('aria-controls')) {
                    tab.setAttribute('aria-controls', `jdgm-tabpanel-${index}`);
                    }

                    // Handle click activation
                    tab.addEventListener('click', () => activateTab(tab));

                    // Keyboard navigation
                    tab.addEventListener('keydown', e => {
                    const curr = tabs.indexOf(tab);
                    let next = null;

                    if (e.key === 'ArrowRight') {
                        next = tabs[curr + 1] || tabs[0];
                    } else if (e.key === 'ArrowLeft') {
                        next = tabs[curr - 1] || tabs[tabs.length - 1];
                    } else if (e.key === 'Home') {
                        next = tabs[0];
                    } else if (e.key === 'End') {
                        next = tabs[tabs.length - 1];
                    } else if (e.key === 'Enter' || e.key === ' ') {
                        activateTab(tab);
                    }

                    if (next) {
                        e.preventDefault();
                        next.focus();
                    }
                    });
                });

                function activateTab(selected) {
                    tabs.forEach(tab => {
                    const isSelected = tab === selected;
                    tab.classList.toggle('jdgm--active', isSelected);
                    tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
                    tab.tabIndex = isSelected ? 0 : -1;
                    });
                }

                tabsObserver.disconnect();
            });

            tabsObserver.observe(container, {
                subtree: true,
                childList: true
            })
        }

        function fixReviewItem(item) {
            item.setAttribute('role', 'group');
            const reviewId = item.getAttribute('data-review-id');
            const userContainer = item.querySelector('.jdgm-rev__author-wrapper');
            userContainer.id = reviewId;
            item.setAttribute('aria-labelledby', userContainer.id);
            const icon = item.querySelector('.jdgm-rev__icon');
            if (icon) {
                icon.setAttribute('aria-hidden', 'true');
            }

            const rating = item.querySelector('.jdgm-rev__rating');
            if (rating) {
                const value = rating.getAttribute('data-score');
                rating.setAttribute('aria-label', `${value} out of 5 stars`);
                rating.removeAttribute('tabindex');
            }

            listenToThumbsUp(item);

            function listenToThumbsUp(item) {
                const observer = new MutationObserver(() => {
                    const voteContainer = item.querySelector('.jdgm-rev__votes-inner');
                    if (voteContainer) {
                        const username = userContainer.querySelector('.jdgm-rev__author').innerText;
                        const voteNumbers = voteContainer.querySelectorAll('.jdgm-rev__thumb-count');
                        voteContainer.querySelectorAll('.jdgm-rev__thumb-btn').forEach((voteBtn, index) => {
                            voteBtn.setAttribute('role', 'button');
                            voteBtn.removeAttribute('title');
                            voteNumbers[index].id = `vote_${index}_${reviewId}`;

                            const isPositive = voteBtn.classList.contains('jdgm-rev_thumb-up');
                            voteBtn.setAttribute('aria-label', `${username}'s review ${isPositive ? 'was' : 'was not'} helpful`);
                            voteBtn.setAttribute('aria-describedby', voteNumbers[index].id);

                            const oldValue = voteNumbers[index].innerText;

                            const verifyPress = () => {
                                setTimeout(() => {
                                    const newValue = voteNumbers[index].innerText;
                                    if (newValue !== oldValue) {
                                        voteBtn.setAttribute('aria-pressed', 'true');
                                    }
                                }, 500);

                            }
                            voteBtn.addEventListener('click', verifyPress);
                            voteBtn.addEventListener('keydown', (e) => {
                                if (e.key === 'Enter') {
                                    verifyPress();
                                }
                            });
                        });

                        observer.disconnect();
                    }
                });

                observer.observe(item, {
                    subtree: true,
                    childList: true
                });
            }


        }

        function fixRatingSection(container) {
            const list = container.querySelector('.jdgm-histogram');
            if (!list) return;
            
            list.setAttribute('role', 'list');
            list.setAttribute('aria-label', 'Ratings Distribution');

            const totalReviews = container.querySelector('.jdgm-rev-widg__summary-text');

            if(totalReviews) {
                totalReviews.id = "summary_id_text";
            }

            list.querySelectorAll('.jdgm-histogram__row').forEach(row => {
                let barFrequencyText = '';
                
                const currentRatingText = row.getAttribute('data-rating') || 0;
                if(!row.classList.contains('jdgm-histogram__clear-filter')) {
                    row.setAttribute('role', 'listitem');
                    row.querySelectorAll('.jdgm-histogram__percentage, .jdgm-histogram__frequency').forEach((el, index) => {
                        barFrequencyText += el.innerText + (index === 0 ? ", " : " reviews.");
                        el.setAttribute('aria-hidden', 'true');
                    });
                    const stars = row.querySelector('.jdgm-histogram__star');
                    if(stars) {
                        stars.setAttribute('aria-label', `${currentRatingText} out of 5 stars, ${barFrequencyText}`);
                    }

                    
                }else {
                    row.setAttribute('role','button');
                }

            });
        }

        function fixBadges(container) {
            const badgeContainer = container.querySelector('.jdgm-medals .jdgm-medals__container');
            if (!badgeContainer) return;

            badgeContainer.setAttribute('aria-label', 'Judge.me badges');
            badgeContainer.setAttribute('role', 'list');
            badgeContainer.querySelectorAll('.jdgm-medal-wrapper').forEach(badge => {
                badge.setAttribute('role', 'listitem');
                badge.removeAttribute('title');
            })
        }

        function fixAverage(container) {
            const average = container.querySelector('.jdgm-rev-widg__summary-stars');
            if(!average) return;
            const currentName = average.getAttribute('aria-label');
            if(currentName) {
                average.setAttribute('aria-label', currentName + ' out of 5 stars.');
            }
            
            average.querySelectorAll('.jdgm-star').forEach(star => {
                star.setAttribute('aria-hidden', 'true');
            })
        }

        function fixCountdown(container) {
            const formObserver = new MutationObserver(() => {
                const formWrapper = container.querySelector('.jdgm-form-wrapper');
                if (formWrapper && formWrapper.style.display !== 'none') {
                    const countdowns = formWrapper.querySelectorAll('.jdgm-countdown');

                    const select = formWrapper.querySelector('.jdgm-form__reviewer-name-format-dropdown');
                    if (select && !select.hasAttribute('data-focus-set')) {
                        select.setAttribute('data-focus-set', 'true');
                        setTimeout(() => select.focus(), 300);
                    }

                    countdowns.forEach((countdown, index) => {
                        if (countdown.hasAttribute('data-countdown-fixed')) return;
                        countdown.setAttribute('data-countdown-fixed', 'true');
                        countdown.id = `countdown_`+index;

                        const formFieldContainer = countdown.closest('.jdgm-form__fieldset');
                        if(formFieldContainer) {
                            const field = formFieldContainer.querySelector('input, textarea');
                            if(field) {
                                field.setAttribute('aria-describedby', countdown.id);
                            }
                        }

                        const observer = new MutationObserver(() => {
                            if (countdown.textContent.trim() && !countdown.querySelector('.visually-hidden')) {
                                const hiddenSpan = document.createElement('span');
                                hiddenSpan.className = 'visually-hidden';
                                hiddenSpan.textContent = ' characters remaining';
                                countdown.appendChild(hiddenSpan);
                            }
                        });

                        observer.observe(countdown, {
                            childList: true,
                            characterData: true,
                            subtree: true
                        });

                        if (countdown.textContent.trim() && !countdown.querySelector('.visually-hidden')) {
                            const hiddenSpan = document.createElement('span');
                            hiddenSpan.className = 'visually-hidden';
                            hiddenSpan.textContent = ' characters remaining';
                            countdown.appendChild(hiddenSpan);
                        }
                    });
                }
            });

            formObserver.observe(container, {
                childList: true,
                subtree: true
            });
        }

        function fixAskQuestionForm(container) {
            const formObserver = new MutationObserver(() => {
                const formWrapper = container.querySelector('.jdgm-question-form-wrapper');
                if (formWrapper && formWrapper.style.display !== 'none') {
                    const titleAskQuestion = container.querySelector('.jdgm-question-form-wrapper div.jdgm-form__title');
                    if(titleAskQuestion) {
                        const h3 = document.createElement('h3');
                        h3.innerText = titleAskQuestion.innerText;
                        h3.className = titleAskQuestion.className;
                        titleAskQuestion.replaceWith(h3);
                    }

                    const nameInput = container.querySelector('#jdgm_question_reviewer_name:not([autocomplete])');
                    if(nameInput) {
                        nameInput.setAttribute('autocomplete', 'name')
                        // nameInput.setAttribute('aria-required', 'true')
                    }

                    const emailInput = container.querySelector('#jdgm_question_reviewer_email:not([autocomplete])');
                    if(emailInput) {
                        emailInput.setAttribute('autocomplete', 'email')
                        // emailInput.setAttribute('aria-required', 'true')
                    }
                    const formContainer = container.querySelector('.jdgm-question-form:not([applied])')
                    if(formContainer) {
                        formContainer.querySelectorAll('label').forEach(label => {
                            label.innerText = label.innerText + '*'
                        });
                        // const questionTextArea = container.querySelector('#jdgm_question_content');
                        // if(questionTextArea) {
                        //     questionTextArea.setAttribute('aria-required', 'true')
                        // }
                        formContainer.setAttribute('applied', 'true');
                    }
                }
            });

            formObserver.observe(container, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style']
            });
        } 


        function fixEmailValidationMessage(container) {
            const formObserver = new MutationObserver(() => {
                const formWrapper = container.querySelector('.jdgm-form-wrapper');
                if (formWrapper && formWrapper.style.display !== 'none') {
                    const form = formWrapper.querySelector('form:not([applied])');
                    if(form) {
                        form.setAttribute('applied', 'true');
                        form.querySelectorAll('input[name="reviewer_name"], input[name="reviewer_email"]').forEach(input => {
                            const parent = input.parentNode;
                            const label = parent.querySelector('label');
                            label.innerText = label.innerText+'*';

                            if(input.getAttribute('name') === 'reviewer_name') {
                                input.setAttribute('autocomplete', 'name');
                                input.setAttribute('aria-required', 'true');
                            } else {
                                input.setAttribute('autocomplete', 'email');
                                input.setAttribute('aria-required', 'true');
                            }
                        });
                        const textarea = form.querySelector('textarea');
                        textarea.setAttribute('aria-required', 'true');
                        const parent = textarea.closest('.jdgm-form__body-fieldset');
                        const label = parent.querySelector('label');
                        label.innerText = label.innerText + '*';

                        const stars = form.querySelector('.jdgm-form__rating-fieldset');
                        const labelStars = stars.querySelector('label');
                        labelStars.innerText = labelStars.innerText + '*';
                        
                        const fileInput = document.querySelector('input[type="file"]');
                        if(fileInput) {
                            fileInput.title = '';
                        }

                        new MutationObserver(()=> {
                            const deleteBtn = form.querySelector('.jdgm-picture-fieldset__delete');
                            if(deleteBtn) {
                                deleteBtn.setAttribute('aria-label', 'Remove media');
                                deleteBtn.setAttribute('role', 'button');
                                deleteBtn.setAttribute('tabindex', '0');
                            }
                        }).observe(form, {subtree: true, childList: true});

                        makeStarsRadioGroup(form);
                    }

                    const titleAskQuestion = formWrapper.querySelector('h2.jdgm-form__title');
                    if (titleAskQuestion) {
                        const h3 = document.createElement('h3');
                        h3.innerText = titleAskQuestion.innerText;
                        h3.className = titleAskQuestion.className;
                        titleAskQuestion.replaceWith(h3);
                    }

                    const emailFieldset = formWrapper.querySelector('.jdgm-form__email-fieldset');
                    if (!emailFieldset) return;

                    if (emailFieldset.hasAttribute('data-email-error-fixed')) return;
                    emailFieldset.setAttribute('data-email-error-fixed', 'true');

                    const emailInput = emailFieldset.querySelector('input[type="email"]');
                    if (!emailInput) return;

                    const applyMessage = () => {
                        const describedBy = emailInput.getAttribute('aria-describedby');
                        let errorElement = null;

                        if (describedBy) {
                            errorElement = document.getElementById(describedBy);
                        }

                        if (!errorElement) {
                            errorElement = emailFieldset.querySelector('.jdgm-input-error');
                        }

                        if (errorElement && errorElement.textContent.trim() === 'Please enter a valid email address.') {
                            errorElement.textContent = 'Please enter a valid email address in the format user@example.com';
                        }
                    };

                    applyMessage();

                    const observer = new MutationObserver(() => {
                        applyMessage();
                    });

                    observer.observe(emailFieldset, {
                        childList: true,
                        subtree: true,
                        attributes: true,
                        attributeFilter: ['class', 'aria-invalid', 'aria-describedby']
                    });
                }
            });

            formObserver.observe(container, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style']
            });
        }

        function makeStarsRadioGroup(container) {
            const stars = Array.from(container.querySelectorAll('.jdgm-star'));
            const input = container.querySelector('input[name="score"]');

            if(!stars.length) return;
            container.setAttribute('role', 'radiogroup');

            const parent = stars[0].parentNode;
            if(parent) {
                parent.className = parent.className+"2";
            }

            // Init stars
            stars.forEach((star, index) => {
                star.setAttribute('role', 'radio');
                star.setAttribute('tabindex', index === 0 ? '0' : '-1');
                star.setAttribute('aria-checked', 'false');
                star.removeAttribute('title');

                // Mouse
                star.addEventListener('click', () => {
                    select(index, { focus: false });
                });

                // Keyboard
                star.addEventListener('keydown', e => {
                    switch (e.key) {
                        case 'Enter':
                        case ' ':
                            e.preventDefault();
                            select(index);
                            break;
                        case 'ArrowRight':
                            move(index + 1);
                            break;
                        case 'ArrowLeft':
                            move(index - 1);
                            break;
                    }
                });
            });

            function select(i, { focus = true } = {}) {
                if (i < 0 || i >= stars.length) return;

                stars.forEach((star, idx) => {
                    const isOn = idx <= i;
                    const isSelected = idx === i;

                    star.classList.toggle('jdgm--on', isOn);
                    star.classList.toggle('jdgm--off', !isOn);
                    star.setAttribute('aria-checked', isSelected ? 'true' : 'false');
                    star.tabIndex = isSelected ? 0 : -1;
                });

                if (focus) {
                    stars[i].focus();
                }
                
                const parent = stars[0].parentNode;
                if(parent) {
                    parent.querySelector('input').setAttribute('aria-invalid', parent.querySelectorAll('a.jdgm--on').length ? 'false' : 'true');
                }
                input.value = stars[i].dataset.alt;
            }

            function move(i) {
                if (i < 0 || i >= stars.length) return;

                stars.forEach(s => (s.tabIndex = -1));
                stars[i].tabIndex = 0;
                stars[i].focus();
            }
        }


        function fixNotificationAlert(container) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach(mutation => {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1 && node.classList.contains('jdgm-notification')) {
                            const titleElement = node.querySelector('.jdgm-notification__title');
                            if (titleElement && !titleElement.hasAttribute('data-alert-role-added')) {
                                titleElement.setAttribute('role', 'alert');
                                titleElement.setAttribute('data-alert-role-added', 'true');
                            }
                        }
                    });
                });
            });

            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }

        function focusFirstErrorOnSubmit(container) {
            const formObserver = new MutationObserver(() => {
                const formWrapper = container.querySelector('.jdgm-form-wrapper');
                if (formWrapper && formWrapper.style.display !== 'none') {
                    const form = formWrapper.querySelector('.jdgm-form');
                    if (!form || form.hasAttribute('data-focus-error-attached')) return;

                    form.setAttribute('data-focus-error-attached', 'true');

                    form.addEventListener('submit', () => {
                        setTimeout(() => {
                            const errors = form.querySelectorAll('[aria-invalid="true"]');
                            if (errors.length > 0) {
                                const field = errors[0];
                                //Changed the class for stars to stop listening to the library star update
                                const fieldset = field.closest('.jdgm-form__rating2');
                                if(fieldset) {
                                    fieldset.querySelector('input').setAttribute('aria-invalid', fieldset.querySelectorAll('a.jdgm--on').length ? 'false' : 'true');
                                    const firstStar = fieldset.querySelector('a');
                                    if(firstStar) {
                                        firstStar.focus();
                                    }
                                    
                                    
                                } else {
                                    field.focus();
                                }
                                
                            }
                        }, 150);
                    });
                }
            });

            formObserver.observe(container, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style']
            });
        }

        function fixQuestionsSection(container) {
            const observer = new MutationObserver((mutations) => {
                const questionsContainer = container.querySelector('.jdgm-quest-widg__body');
                if(!questionsContainer) return;

                questionsContainer.querySelectorAll('.jdgm-quest').forEach((item, index) => {
                    item.setAttribute('role', 'group');
                    const author = item.querySelector('.jdgm-rev__author');
                    if(author) {
                        author.id = `quest_${index}`;
                        item.setAttribute('aria-labelledby', author.id)
                    }

                    const profile = item.querySelector('.jdgm-rev__icon');
                    if(profile) {
                        profile.setAttribute('aria-hidden', 'true');
                    }
                });
            });

            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }

    }

    fixReviews();

    function fixThumbnailRedundantLink() {
        document.querySelectorAll(`.ada-span-link`).forEach(element => {
            const href = element.getAttribute('href');

            if(href) {
                element.style.cursor = 'pointer'
                element.addEventListener('click', () => {
                    window.location.href = href;
                });
            }
        });
    }

    fixThumbnailRedundantLink();


    function sliderOnMobile(parentSelector, childSelector) {
        if(window.innerWidth < 768) {
            document.querySelectorAll(parentSelector).forEach(container => {
                const slides = container.querySelectorAll(childSelector);
                addSliderSemantics(container, slides);
                appendSliderArrows(slides, container);
                intersectionObserverAda(slides, container);
            });
        }
    }

    sliderOnMobile('.featured-collection__container', '.product-grid-item');
    sliderOnMobile('.testimonials__wrapper', '.testimonial__item');
    sliderOnMobile('.section-columns__wrapper', '.column-item');
    sliderOnMobile('.featured-blog__container', '.blog__post-item');

    function addSliderSemantics(container, slides) {
        container.setAttribute('role', 'region');

        const list = container.querySelector('[role="list"]');

        if(list) {
            list.removeAttribute('role');
        }

        const firstChild = container.querySelector(':scope > div');

        if(firstChild) {
            firstChild.tabIndex = '-1';
        }

        const oldList = container.querySelector('[role="list"]');
        if(oldList) {
            const ariaLabel = oldList.getAttribute('aria-label');
            if(ariaLabel) {
                container.setAttribute('aria-label', ariaLabel);
                oldList.removeAttribute('role');
                oldList.removeAttribute('aria-label');
            }
        }
        slides.forEach((slide, index) => {
            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-label', `Slide ${index + 1} of ${slides.length}`);

            const modalLink = slide.querySelector('.product-single__media-link');
            const imgProduct = slide.querySelector('.img-object-cover');

            if(modalLink) {
                modalLink.setAttribute('aria-label', `View fullscreen: Product media ${index + 1}`);
            }

            if(imgProduct) {
                imgProduct.setAttribute('alt', `Product media ${index + 1} of ${slides.length}`);
            }
        });
    }


    function appendSliderArrows(slides, wrapperContainer) {
        /* --------------------
            Create arrows
        --------------------- */
        const controls = document.createElement('div');
        controls.className = 'tent-slider-controls';
        controls.setAttribute('role', 'group');
        controls.setAttribute('aria-label', 'Slider controls');

        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'ally-carousel-btn prev';
        prevBtn.setAttribute('aria-label', 'Previous slide');
        prevBtn.innerHTML = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        `;

        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'ally-carousel-btn next';
        nextBtn.setAttribute('aria-label', 'Next slide');
        nextBtn.innerHTML = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        `;

        wrapperContainer.style.position = 'relative';

        // controls.append(prevBtn, nextBtn);
        wrapperContainer.append(prevBtn, nextBtn);
        let currentIndex = 0;

        function moveTo(index) {
            currentIndex = Math.max(0, Math.min(index, slides.length - 1));

            slides[currentIndex].scrollIntoView({
                behavior: 'smooth',
                inline: 'start',
                block: 'nearest'
            });
        }

        prevBtn.addEventListener('click', () => moveTo(currentIndex - 1));
        nextBtn.addEventListener('click', () => moveTo(currentIndex + 1));
    }

    function intersectionObserverAda(slides, parent, visibilityPercentage = 0.9) {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    const isVisible = entry.intersectionRatio >= visibilityPercentage;
                    entry.target.setAttribute(
                    'aria-hidden',
                    isVisible ? 'false' : 'true'
                    );

                    entry.target.querySelectorAll('a, button, [tabindex]').forEach(element => {
                        element.setAttribute('tabindex', isVisible ? '0' : '-1');
                    });
                });
            },
            {
            root: parent,
            threshold: [visibilityPercentage]
            }
        );

        slides.forEach(slide => observer.observe(slide));
    }

    //////////////////////
    function handleNewCarousel(carousel) {
        // Avoid duplicates
        if (carousel._modified) return;
        carousel._modified = true;
        carousel.removeAttribute('tabindex');

        //HERE WE NEED TO PUT ALL CHILDREN CLASSES OF EACH PARENT
        //IT MAY VARY SINCE WE CAN HAVE MULTIPLE SLIDERS FOR DIFFERENT SECTIONS
        const slides = carousel.querySelectorAll('.product-grid-item, .testimonial__item, .column-item, .product-single__media-slide, .product-single__thumbnail');
        addSliderSemantics(carousel, slides);
    }

    function listenToFlickitySliders() {
        document.querySelectorAll('.flickity-enabled:not(.skip)')
            .forEach(handleNewCarousel);

        const obs = new MutationObserver((mutations) => {
            for (const m of mutations) {

                // New nodes added
                if (m.type === 'childList') {
                    for (const node of m.addedNodes) {
                        if (!(node instanceof HTMLElement)) continue;

                        if (node.classList.contains('flickity-enabled')) {
                            handleNewCarousel(node);
                        }

                        node.querySelectorAll?.('.flickity-enabled')
                            .forEach(handleNewCarousel);
                    }
                }

                // Existing nodes getting the class later
                if (m.type === 'attributes' && m.attributeName === 'class') {
                    const el = m.target;

                    if (el.classList.contains('flickity-enabled')) {
                        handleNewCarousel(el);
                    }
                }
            }
        });

        obs.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }

    listenToFlickitySliders();


    document.querySelectorAll('.collection__sort__option-wrapper').forEach(wrapper => {

        const labels = [...wrapper.querySelectorAll('.collection__sort__button')];

        wrapper.addEventListener('keydown', (e) => {
            if (!e.target.matches('.collection__sort__button')) return;

            const index = labels.indexOf(e.target);
            labels.forEach(item => item.tabIndex = -1);
            // Arrow navigation
            if (['ArrowDown','ArrowRight','ArrowUp','ArrowLeft'].includes(e.key)) {
            e.preventDefault();

            let nextIndex = index;

            if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
                nextIndex = (index + 1) % labels.length;
            }

            if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
                nextIndex = (index - 1 + labels.length) % labels.length;
            }
            labels[nextIndex].tabIndex = '0';
            labels[nextIndex].focus();
            }

            // Activate option
            if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.target.click(); // triggers the hidden radio via label
            }
        });

        });



        function groupAccordionsAndAddListSemantics() {
            
            const accordions = document.querySelectorAll('.product__accordions');

            if (accordions.length) {
                const wrapper = document.createElement('div');
                wrapper.setAttribute('role', 'list');
                wrapper.setAttribute('aria-label', 'Product information');

                const parent = accordions[0].parentNode;
                parent.insertBefore(wrapper, accordions[0]);

                accordions.forEach(acc => {
                    acc.setAttribute('role', 'listitem');
                    wrapper.appendChild(acc);
                });
            }
        }

        groupAccordionsAndAddListSemantics();

        function addAccessibleNameToCollectionPage() {
            if (!window.location.pathname.startsWith('/collections/')) return;
            const heading = document.querySelector('.section-header__title');
            if(heading) {
                const grid = document.querySelector('.collection__products .grid');
                if(grid) {
                    grid.setAttribute('aria-label', heading.textContent);
                }
            }
        }

        addAccessibleNameToCollectionPage();


        function fixProductPlanFocusVisibility() {
            const planPicker = document.querySelector('skio-plan-picker');

            if (planPicker && planPicker.shadowRoot) {
                const shadow = planPicker.shadowRoot;
                
                // You can now modify elements inside or inject CSS

                const style = document.createElement('style');
                style.textContent = `
                    *:focus, *:focus-visible, .selling-plan-dropdown-container:has(.selling-plan-dropdown:focus-visible){
                    outline: .1rem solid rgba(0, 0, 0, .8) !important;
                    outline-offset: .3rem !important;
                    box-shadow: 0 0 0 .15rem rgb(255, 255, 255), 0 0 .2rem .2rem rgba(0, 0, 0, .3) !important;
                    }

                    .selling-plan-dropdown:focus-visible {
                        outline: none !important;
                        box-shadow: none !important;
                    }
                `;

                // Append to shadow root
                planPicker.shadowRoot.appendChild(style);
            }
        }

        fixProductPlanFocusVisibility();

        //if there are 2 h1 update the headings
        function headingsOnProductsLanding() {

            function replaceTag(element, newTagName) {
                if (!element || element.tagName.toLowerCase() === newTagName.toLowerCase()) {
                    return element;
                }

                const newElement = document.createElement(newTagName);
                // Copy attributes
                Array.from(element.attributes).forEach((attr) => {
                    newElement.setAttribute(attr.name, attr.value);
                });

                // Copy content
                newElement.innerHTML = element.innerHTML;

                // Replace element
                element.replaceWith(newElement);
                return newElement;
            }

            const h1s = document.querySelectorAll(
                'h1#ally_product_title, .text-highlight__break h1'
            );

            const hasMoreThanOneH1 = h1s.length > 1;

            if (hasMoreThanOneH1) {
                replaceTag(h1s[1], 'h2');
            }

            const mageplazaHeading = document.querySelector(
                '.Mageplaza-MediaBlock__TopHeader.Heading'
            );

            const reviewTitle = document.querySelector(
                '.jdgm-rev-widg__title'
            );

            if (mageplazaHeading) {
                replaceTag(mageplazaHeading, hasMoreThanOneH1 ? 'h3' : 'h2');
            }

            if (reviewTitle) {
                replaceTag(reviewTitle, hasMoreThanOneH1 ? 'h3' : 'h2');
            }
        }
        headingsOnProductsLanding();

        function hideRedundantSlider() {
            const slider = document.querySelector('.product-single__thumbnails.skip');
            if(!slider) return;

            slider.setAttribute('aria-hidden', 'true');
            slider.querySelectorAll('a, button').forEach(item => {
                item.setAttribute('tabindex', '-1');
            });
        }

        hideRedundantSlider();



function fixVideoSlider() {
    const instaFeed = document.querySelector('mageplaza_instafeed');
    console.log(instaFeed, 'instaFeed');
    if (!instaFeed) return;

    function updateButtons() {
        instaFeed.querySelectorAll('.Slider--prev, .Slider--next').forEach((btn) => {
            btn.setAttribute('tabindex', '0');
            btn.setAttribute('role', 'button');
            btn.setAttribute('aria-label', btn.className.includes('Slider--prev') ? 'Previous slide' : 'Next slide');

            btn.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    btn.click();
                }
            });
        });
    }

    function setupSlider(slider) {
        const slides = slider.querySelectorAll('.swiper-slide');
        const observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    const slide = entry.target;
                    const isReadable = entry.intersectionRatio >= 1;
                    slide.setAttribute('aria-hidden', isReadable ? 'false' : 'true');
                    const focusableElements = slide.querySelectorAll('[tabindex]');
                    focusableElements.forEach(element => {
                        element.tabIndex = isReadable ? '0' : '-1';
                    });
                });
            },
            { root: slider, threshold: [0, 1, 1] }
        );
        slides.forEach(function (slide) { observer.observe(slide); });
    }

    function addPlayPauseBtn(slider) {
        const sliderSelector = '.swiper';
        const videoSelector = 'video';
        const buttonClass = 'ally-toggle';
        const styleId = 'ally-video-toggle-styles';

        function addStyles() {
            if (document.getElementById(styleId)) return;
            const style = document.createElement('style');
            style.id = styleId;
            style.textContent = `
                ${sliderSelector} {
                    position: relative;
                }

                .${buttonClass} {
                    position: absolute;
                    top: 5px;
                    left: 12px;
                    z-index: 999;
                    min-width: 20px;
                    min-height: 20px;
                    padding: 10px;
                    border-radius: 999px;
                    background: #fff;
                    color: #000;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                }

                .${buttonClass}:focus {
                    outline: 3px solid #005fcc;
                    outline-offset: 3px;
                }`;
            document.head.appendChild(style);
        }

        function getVideos(slider) {
            return Array.from(slider.querySelectorAll(videoSelector));
        }

        function pauseVideos(slider) {
            getVideos(slider).forEach(function (video) {
                video.pause();
            });
        }

        function playVideos(slider) {
            getVideos(slider).forEach(function (video) {
                video.play().catch(function () {
                    // Browser may block play until user interacts.
                });
            });
        }

        function keepVideosPausedManually(slider) {
            slider.dataset.allyVideosPaused = 'true';

            function pauseVideosNow() {
                if (slider.dataset.allyVideosPaused !== 'true') return;
                slider.querySelectorAll('video').forEach(function (video) {
                    try {
                        if (!video.paused) {
                            video.pause();
                        }
                    } catch (error) {
                        console.warn('Could not pause video:', error);
                    }
                });
            }

            slider.querySelectorAll('video').forEach(function (video) {
                if (video.dataset.allyManualPauseGuard === 'true') return;
                video.dataset.allyManualPauseGuard = 'true';
                video.addEventListener('play', function () {
                    requestAnimationFrame(pauseVideosNow);
                });
            });

            if (slider.dataset.allyPauseSliderGuard !== 'true') {
                slider.dataset.allyPauseSliderGuard = 'true';
                slider.addEventListener('mouseenter', pauseVideosNow);
                slider.addEventListener('mouseleave', pauseVideosNow);
                slider.addEventListener('focusin', pauseVideosNow);
                slider.addEventListener('focusout', function () {
                    setTimeout(pauseVideosNow, 0);
                });
            }

            setTimeout(pauseVideosNow, 0);
        }

        function apply(slider) {
            if (slider.querySelector(':scope > .' + buttonClass)) return;
            const button = document.createElement('button');
            button.type = 'button';
            button.className = buttonClass;
            button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>`;
            button.setAttribute('aria-label', 'Pause videos');
            let isPlaying = true;

            button.addEventListener('click', function () {
                isPlaying = !isPlaying;
                if (isPlaying) {
                    slider.dataset.allyVideosPaused = 'false';
                    playVideos(slider);
                    button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>`;
                    button.setAttribute('aria-label', 'Pause videos');
                } else {
                    slider.dataset.allyVideosPaused = 'true';
                    pauseVideos(slider);
                    keepVideosPausedManually(slider);
                    button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="5,3 19,12 5,21"/></svg>`;
                    button.setAttribute('aria-label', 'Play videos');
                }
            });
            slider.prepend(button);
        }

        apply(slider);
        addStyles();
    }

    function applyToSlider(slider) {
        if (slider.dataset.allyApplied === 'true') return;
        slider.dataset.allyApplied = 'true';

        slider.setAttribute('role', 'region');
        slider.setAttribute('aria-label', 'Video slider');

        const slides = slider.querySelectorAll('.swiper-slide');
        slides.forEach((slide, index) => {
            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-label', `Slide ${index + 1} of ${slides.length}`);

            const mediaBtn = slide.querySelector('.mp__media-container');
            if (mediaBtn) {
                mediaBtn.setAttribute('aria-label', `Product's Video ${index + 1}`);
                mediaBtn.setAttribute('aria-haspopup', 'dialog');
                mediaBtn.tabIndex = 0;
                mediaBtn.setAttribute('role', 'button');
                mediaBtn.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        mediaBtn.click();
                    }
                });
            }
        });

        updateButtons();
        setupSlider(slider);
        addPlayPauseBtn(slider);
    }

    // Run immediately if slider already exists
    const existingSlider = instaFeed.querySelector('.Mageplaza__Slider--Container');
    if (existingSlider) {
        applyToSlider(existingSlider);
    }

    // Also watch for it being added later
    const observer = new MutationObserver(() => {
        const slider = instaFeed.querySelector('.Mageplaza__Slider--Container');
        if (!slider) return;
        applyToSlider(slider);
    });

    observer.observe(instaFeed, { subtree: true, childList: true });
}

fixVideoSlider();

function watchPopupRoot() {
    function applyPopupAccessibility(popupContent) {
        popupContent.setAttribute('aria-modal', 'true');
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                const icon = e.target.closest('.MP-XIcon');
                if (!icon) return;
                e.preventDefault();
                icon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            }
        });



        setTimeout(() => {
            const closeBtn = popupContent.querySelector('.MP-XIcon');
            if (closeBtn && closeBtn.dataset.allyApplied !== 'true') {
                closeBtn.dataset.allyApplied = 'true';
                addButtonSemantics(closeBtn);
                closeBtn.setAttribute('aria-label', 'Close');
            }

            ['.Slider--prev', '.Slider--next'].forEach((selector) => {
                const arrow = popupContent.querySelector(selector);
                if (!arrow || arrow.dataset.allyApplied === 'true') return;
                arrow.dataset.allyApplied = 'true';
                addButtonSemantics(arrow);
                arrow.setAttribute('aria-label', selector.includes('prev') ? 'Previous slide' : 'Next slide');
            });

            ['.Mageplaza-Popup__ArrowLeft', '.Mageplaza-Popup__ArrowRight'].forEach((selector) => {
                const arrow = popupContent.querySelector(selector);
                if (!arrow || arrow.dataset.allyApplied === 'true') return;
                arrow.dataset.allyApplied = 'true';
                addButtonSemantics(arrow);
                arrow.setAttribute('aria-label', selector.includes('Left') ? 'Previous Story' : 'Next Story');
            });
        }, 1000);
    }

    function addButtonSemantics(button) {
        if (!button) return;
        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');
    }

    function onPopupContentReady(popupRoot) {
        const innerObserver = new MutationObserver(() => {
            const popupContent = popupRoot.querySelector('.popup-content');
            if (!popupContent) return;

            // ✅ No guard here — re-apply every time content changes
            applyPopupAccessibility(popupContent);
        });

        innerObserver.observe(popupRoot, { subtree: true, childList: true });

        const existingContent = popupRoot.querySelector('.popup-content');
        if (existingContent) {
            applyPopupAccessibility(existingContent);
        }
    }

    const rootObserver = new MutationObserver(() => {
        const popupRoot = document.querySelector('#popup-root');
        if (!popupRoot) return;
        if (popupRoot.dataset.allyWatching === 'true') return;
        popupRoot.dataset.allyWatching = 'true';
        onPopupContentReady(popupRoot);
    });

    rootObserver.observe(document.body, { subtree: true, childList: true });
}

watchPopupRoot();
(function() {


    // 1. Inject Styles
    const style = document.createElement('style');
    style.textContent = `
        /* Control Bar Styling */
        .marquee-controls {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 20px;
            margin: 15px 0;
            font-family: sans-serif;
            position: absolute;
            top: -45px;
            left: 20px;
            z-index: 100;
        }
        .marquee-controls button {
            background: #fff;
            color: #000;
            border: 1px solid #333;
            cursor: pointer;
            height: 25px;
            width: 25px;
            font-size: 11px;
            border-radius: 50%;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        @media (max-width: 500px) {
            .marquee-controls {
                top: -40px;
            }
        }
        .marquee-controls button:active {
            transform: scale(0.95);
        }

        /* Animation States */
        .slider-container:has(.announcement__slider.marquee).marquee-paused .ticker--animated {
            animation-play-state: paused !important;
        }
        .slider-container:has(.announcement__slider.marquee).marquee-reverse .ticker--animated {
            animation-direction: reverse !important;
        }

        /* Layout Fixes for Seamless Looping */
        .slider-container:has(.announcement__slider.marquee) .announcement__scale {
            display: flex !important;
            width: max-content !important;
            transition: transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        .slider-container:has(.announcement__slider.marquee) .ticker--animated {
            animation-iteration-count: infinite !important;
            flex-shrink: 0 !important;
        }
    `;
    document.head.appendChild(style);



    document.querySelectorAll('.slider-container:has(.announcement__slider.marquee)').forEach(marqueeContainer => {
        // 2. Create and Inject Buttons
        const controls = document.createElement('div');
        controls.className = 'marquee-controls';
        controls.innerHTML = `
            <button class="marquee-prev" aria-label="Previous">←</button>
            <button class="marquee-toggle" aria-label="Pause slide">❚❚</button>
            <button class="marquee-next" aria-label="Next">→</button>
        `;
        marqueeContainer.before(controls);
        marqueeContainer.style.overflow = 'hidden';
        const parent = marqueeContainer.parentElement;
        if(parent) {
            parent.style.overflow = 'visible';
            parent.style.position = 'relative';
            parent.setAttribute('role', 'region');
            parent.setAttribute('aria-label', 'Slider')
        }
        

        // 3. Logic & Event Listeners
        const toggleBtn = parent.querySelector('.marquee-toggle');
        const prevBtn = parent.querySelector('.marquee-prev');
        const nextBtn = parent.querySelector('.marquee-next');
        const scale = marqueeContainer.querySelector('.announcement__scale');
        
        let currentOffset = 0;
        const stepSize = 250; // Distance to jump on arrow click

        // Play/Pause Toggle
        toggleBtn.addEventListener('click', () => {
            const isPaused = marqueeContainer.classList.toggle('marquee-paused');
            toggleBtn.textContent = isPaused ? '▶' : '❚❚';
            toggleBtn.setAttribute('aria-label', isPaused ? 'Play slider' : 'Pause slider');
        });

        // Left Arrow (Reverse + Push)
        prevBtn.addEventListener('click', () => {
            currentOffset += stepSize;
            scale.style.transform = `translateX(${currentOffset}px)`;
            marqueeContainer.classList.add('marquee-reverse');
        });

        // Right Arrow (Normal + Push)
        nextBtn.addEventListener('click', () => {
            currentOffset -= stepSize;
            scale.style.transform = `translateX(${currentOffset}px)`;
            marqueeContainer.classList.remove('marquee-reverse');
        });
    });
    


})();
(function() {
  document.querySelectorAll('.announcement__slider.marquee').forEach(slider => {
      /**
   * Scans all announcement blocks and sets tabindex="0" only for those 
   * currently visible within the slider container.
   */
  function updateBlockAccessibility() {
    const sliderRect = slider.getBoundingClientRect();
    const blocks = slider.querySelectorAll('.announcement__block');

    blocks.forEach(block => {
      const rect = block.getBoundingClientRect();
      
      // Determine if this block is horizontally within the visible marquee window
      // Includes a 5px buffer for better browser accuracy
      const isVisible = (
        rect.left >= sliderRect.left - 5 && 
        rect.right <= sliderRect.right + 5
      );

      // Set tabindex: 0 for visible items (focusable), -1 for hidden (skipped)
      block.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      block.querySelectorAll('a').forEach(link => {
        block.setAttribute('tabindex', isVisible ? '0' : '-1');
      });
    });
  }


  // Monitor the marquee position continuously (every 300ms)
  let lastUpdate = 0;
  function tickerLoop(time) {
    if (time - lastUpdate > 300) { 
      updateBlockAccessibility();
      lastUpdate = time;
    }
    requestAnimationFrame(tickerLoop);
  }

  requestAnimationFrame(tickerLoop);
  });


})();


function makeDecorativeIconsHidden() {

  const decorativeChars = /([★🌊🌎💧🎋🍋])/gu;
  const isSingleChar = /^[★🌊🌎💧🎋🍋]$/u; // ← no /g, no state issues

  function wrapInTextNodes(node) {
    if (node.nodeType !== Node.TEXT_NODE) {
      if (
        node.nodeType === Node.ELEMENT_NODE &&
        node.tagName === 'SPAN' &&
        node.getAttribute('aria-hidden') === 'true'
      ) return;

      node.childNodes.forEach(child => wrapInTextNodes(child));
      return;
    }

    decorativeChars.lastIndex = 0;
    if (!decorativeChars.test(node.textContent)) return;

    decorativeChars.lastIndex = 0;
    const parts = node.textContent.split(decorativeChars);
    if (parts.length <= 1) return;

    const fragment = document.createDocumentFragment();

    parts.forEach(part => {
      if (part === '') return;

      if (isSingleChar.test(part)) { // ← stateless, always reliable
        const span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        span.textContent = part;
        fragment.appendChild(span);
      } else {
        fragment.appendChild(document.createTextNode(part));
      }
    });

    node.parentNode.replaceChild(fragment, node);
  }

  document.body && wrapInTextNodes(document.body);
}

makeDecorativeIconsHidden();

function appendStarToRequiredEmailField() {

    const observer = new MutationObserver(() => {
        const emailLabel = document.querySelector('.klaviyo-form input[name="email"]');
        if(emailLabel) {
            emailLabel.setAttribute('placeholder', emailLabel.getAttribute('placeholder') + '*');
            observer.disconnect();

            const heading = document.querySelector('.klaviyo-form h1');
            if(heading) {
                const h2 = document.createElement('h2');
                h2.innerHTML = heading.innerHTML;

                // Copy over any attributes (class, id, style, etc.)
                for (const attr of heading.attributes) {
                    h2.setAttribute(attr.name, attr.value);
                }

                heading.replaceWith(h2);
            }
        }
    });

    observer.observe(document.body, {
        subtree: true,
        childList: true
    })

}

appendStarToRequiredEmailField();

function hideBrHr() {
  const SELECTOR = 'br, hr';

  function applyAriaHidden(el) {
    if (el.getAttribute('aria-hidden') !== 'true') {
      el.setAttribute('aria-hidden', 'true');
    }
  }

  // Apply to all existing elements
  const existing = document.querySelectorAll(SELECTOR);
  existing.forEach(applyAriaHidden);

  // Watch for dynamically added elements
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;

        // Check the node itself
        if (node.matches(SELECTOR)) {
          applyAriaHidden(node);
        }

        // Check any descendants (e.g. a <div> inserted containing a <hr>)
        node.querySelectorAll?.(SELECTOR).forEach(applyAriaHidden);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true, // detect added/removed direct children
    subtree: true,   // watch the full DOM tree
  });

  return {
    count: existing.length,
    disconnect: () => observer.disconnect(),
  };
}

hideBrHr();

/**
 * Adds aria-live="polite" to .product-single__media-slider when focus moves
 * within it, and removes it when focus leaves.
 */
    function watchMediaSliderFocus() {
        const SELECTOR = '.product-single__media-slider';

        function handleFocusIn(e) {
            const slider = e.target.closest(SELECTOR);
            if (slider) {
            slider.setAttribute('aria-live', 'polite');
            }
        }

        function handleFocusOut(e) {
            const slider = e.target.closest(SELECTOR);
            if (!slider) return;

            // relatedTarget is the element receiving focus next
            // If it's still inside the slider, don't remove aria-live
            if (slider.contains(e.relatedTarget)) return;

            slider.removeAttribute('aria-live');
        }

        document.addEventListener('focusin', handleFocusIn);
        document.addEventListener('focusout', handleFocusOut);

        return {
            disconnect() {
            document.removeEventListener('focusin', handleFocusIn);
            document.removeEventListener('focusout', handleFocusOut);
            },
        };
    }

    watchMediaSliderFocus();

    function fixCart() {
        const observer = new MutationObserver(() => {
            const cart = document.querySelector('.ocu-cart-drawer');
            if(!cart) return

            fixHeadings(cart);
            fixCartImages(cart);
            fixCardsList(cart);
            observer.disconnect();
            
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixCart();

    function fixHeadings(cart) {
        const headingObserver = new MutationObserver(() => {
            const headline = cart.querySelector('header.ocu-headline');
            
            if (headline && !headline.hasAttribute('data-heading-fixed')) {
                headline.setAttribute('data-heading-fixed', 'true');
                headline.setAttribute('role', 'heading');
                headline.setAttribute('aria-level', '2');
            }

            const title = cart.querySelector('.ocu-cart-header--title');
            
            if (title && !title.hasAttribute('data-heading-fixed')) {
                title.setAttribute('data-heading-fixed', 'true');
                title.setAttribute('aria-level', '1');
            }
        });

        headingObserver.observe(cart, {
            childList: true,
            subtree: true
        });
    }


    function fixCartImages(cart) {
        const applyFixes = () => {
            cart.querySelectorAll('.ocu-cart-line-item-image, .ocu-image__wrapper').forEach(el => {
                if (!el.hasAttribute('data-image-fixed')) {
                    el.setAttribute('data-image-fixed', 'true');
                    el.setAttribute('aria-hidden', 'true');
                    el.setAttribute('tabindex', '-1');
                }
            });
        };

        const imageObserver = new MutationObserver(applyFixes);

        imageObserver.observe(cart, {
            childList: true,
            subtree: true
        });

        // Run immediately in case elements already exist
        applyFixes();
    }

    function fixCardsList(container) {

        let uniqueIdCounter = 0;
        const cardsObserver = new MutationObserver(() => {
            const cardsContainer = container.querySelector('.ocu-alignment__cards-container--embedded');

            if (cardsContainer) {
                cardsObserver.disconnect();

                cardsContainer.setAttribute('role', 'list');

                Array.from(cardsContainer.children).forEach(child => {
                    child.setAttribute('role', 'listitem');

                    const name = child.querySelector('.ocu-name');
                    const addButton = child.querySelector('.ocu-product-add__button');
                    const dropdown = child.querySelector('.ocu-variant__dropdown');

                    if (name && !name.id) {
                        name.id = `ocu-name-${uniqueIdCounter++}`;
                    }

                    if (addButton && name?.id) {
                        addButton.setAttribute('aria-describedby', name.id);
                    }

                    if (dropdown && name?.id) {
                        dropdown.setAttribute('aria-describedby', name.id);
                    }
                });
            }
        });

        cardsObserver.observe(container, {
            childList: true,
            subtree: true
        });
    }
    function carouselA11yAnnouncer() {

  const BUTTON_SELECTOR = '.flickity-button, .ally-carousel-btn';
  const SLIDE_SELECTOR  = '[role="group"]';

  const previousHiddenLabels = new WeakMap();
  const attachedContainers   = new WeakSet();
  const isMultiSlide         = new WeakSet();

  function getCarouselContainer(button) {
    let node = button.parentElement;
    while (node && node !== document.body) {
      if (node.querySelector(SLIDE_SELECTOR)) return node;
      node = node.parentElement;
    }
    return null;
  }

  function getAllSlides(container) {
    return Array.from(container.querySelectorAll(SLIDE_SELECTOR)).map(el => ({
      element: el,
      label:   el.getAttribute('aria-label') || '',
    }));
  }

  function hiddenLabelSet(slides) {
    return new Set(
      slides
        .filter(s => s.element.getAttribute('aria-hidden') === 'true')
        .map(s => s.label)
    );
  }

  function getLiveRegion(container) {
    return container.querySelector('[data-carousel-live]');
  }

  function createLiveRegion(container) {
    if (getLiveRegion(container)) return;

    const live = document.createElement('div');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('aria-atomic', 'true');
    live.setAttribute('aria-hidden', 'true');
    live.setAttribute('data-carousel-live', '');
    live.style.cssText = [
      'position:absolute',
      'width:1px',
      'height:1px',
      'overflow:hidden',
      'clip:rect(0 0 0 0)',
      'white-space:nowrap',
      'border:0',
    ].join(';');

    container.style.position = container.style.position || 'relative';
    container.appendChild(live);
  }

  function updateLiveRegion(container, newSlides) {
    const live = getLiveRegion(container);
    if (!live) return;

    if (newSlides.length > 1) isMultiSlide.add(container);

    live.innerHTML = '';
    live.setAttribute('aria-hidden', 'false');

    setTimeout(() => {
      if (!isMultiSlide.has(container) && newSlides.length === 1) {
        live.appendChild(newSlides[0].element.cloneNode(true));
      } else {
        live.textContent = `${newSlides.length} new slide${newSlides.length === 1 ? '' : 's'}`;
      }
    }, 50);
  }

  function initContainer(container) {
    if (attachedContainers.has(container)) return;

    createLiveRegion(container);

    const allSlides = getAllSlides(container);
    previousHiddenLabels.set(container, hiddenLabelSet(allSlides));

    container.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !container.contains(e.relatedTarget)) {
        const live = getLiveRegion(container);
        if (!live) return;
        live.setAttribute('aria-hidden', 'true');
        live.innerHTML = '';
      }
    });

    attachedContainers.add(container);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;

    const container = getCarouselContainer(button);
    if (!container) return;

    initContainer(container);

    const allBefore    = getAllSlides(container);
    const hiddenBefore = hiddenLabelSet(allBefore);

    setTimeout(() => {
      const allAfter    = getAllSlides(container);
      const hiddenAfter = hiddenLabelSet(allAfter);

      const newSlides = allAfter.filter(
        s => s.element.getAttribute('aria-hidden') !== 'true' && hiddenBefore.has(s.label)
      );

      previousHiddenLabels.set(container, hiddenAfter);

      if (newSlides.length === 0) return;

      updateLiveRegion(container, newSlides);
    }, 300);

  }, true);

  document.addEventListener('focusin', function (event) {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;

    const container = getCarouselContainer(button);
    if (!container) return;

    initContainer(container);

    const live = getLiveRegion(container);
    if (live) live.setAttribute('aria-hidden', 'false');

  }, true);

}

carouselA11yAnnouncer();
})

